import React, { useState } from 'react';
import LowerSeatsData from './LowerSeatsData';
import UpperSeatsData from './UpperSeatsData';
import { axiosapi } from '../../api/axiosapi';
import useAxiosPrivate from "../../hooks/useAxiosPrivate";

const AddBus = (props) => {
    const axiosPrivate = useAxiosPrivate();

    const [upperSeats, setUpperSeats] = useState([]);
    const [lowerSeats, setLowerSeats] = useState([]);




    const [boardingPoint, setBoardingPoint] = useState([{ time: "", pointname: "", pointAddress: "" }]);
    const [droppingPoint, setDroppingPoint] = useState([{ time: "", pointname: "", pointAddress: "" }]);
    const [selectedDays, setSelectedDays] = useState([]);
    const daysOfWeek = [
        { label: 'Monday', value: 1 },
        { label: 'Tuesday', value: 2 },
        { label: 'Wednesday', value: 3 },
        { label: 'Thursday', value: 4 },
        { label: 'Friday', value: 5 },
        { label: 'Saturday', value: 6 },
        { label: 'Sunday', value: 0 },
    ];
    const handleAddBoardingButton = () => {
        setBoardingPoint([...boardingPoint, { time: "", pointname: "", pointAddress: "" }])
    }
    const handleAddDroppingButton = () => {
        setDroppingPoint([...droppingPoint, { time: "", pointname: "", pointAddress: "" }])
    }
    const handleBoardingPoint = (e, index) => {
        let list = [...boardingPoint]
        list[index][`${e.target.name}`] = e.target.value;
        setBoardingPoint(list)


    }
    const handleDroppingPoint = (e, index) => {
        let list = [...droppingPoint]
        list[index][`${e.target.name}`] = e.target.value;
        setDroppingPoint(list)


    }
    const handleRemoveBoardingButton = (index) => {
        const list = [...boardingPoint];
        list.splice(index, 1);
        setBoardingPoint(list);

    }
    const handleRemoveDroppingButton = (index) => {
        const list = [...droppingPoint];
        list.splice(index, 1);
        setDroppingPoint(list);

    }
    const [formData, setFormData] = useState({
        name: '',
        busType: '',
        totalRows: '',
        operatorId: '',
        arrivalTime: '',
        departureTime: '',
        sourceCity: '',
        destinationCity: '',
        boardingPoint: '',
        droppingPoint: ''
    });
    const handleDayChange = (e, day) => {

        if (e.target.checked) {
            setSelectedDays([...selectedDays, day])
        }
        else {
            setSelectedDays(selectedDays.filter((d) => d !== day));
        }
    }


    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleSubmit = (event) => {
        event.preventDefault();

    };

    const handleAddBus = async () => {
        const newBus = {
            userId: props.userid,
            sourceCity: formData.sourceCity,
            destinationCity: formData.destinationCity,
            name: formData.name,
            busType: formData.busType,
            totalRows: formData.totalRows,
            lowerSeats: lowerSeats,
            upperSeats: upperSeats,
            boardingPoint: boardingPoint,
            droppingPoint: droppingPoint,
            departureTime: formData.departureTime,
            arrivalTime: formData.arrivalTime,
            daysOfWeek: selectedDays
        }

        console.log(newBus)
        const response = await axiosPrivate.post("/bus", newBus)
        console.log(response.data)


    }

    return (
        <form onSubmit={handleSubmit} className=" my-4 p-4 bg-white ">
            <div className="mb-4">
                <label htmlFor="name" className="block text-gray-700 font-bold mb-2">
                    Name
                </label>
                <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                />
            </div>
            <div className="mb-4">
                <label htmlFor="busType" className="block text-gray-700 font-bold mb-2">
                    Bus Type
                </label>
                <input
                    type="text"
                    id="busType"
                    name="busType"
                    value={formData.busType}
                    onChange={handleInputChange}
                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                />
            </div>
            <div className="mb-4">
                <label htmlFor="totalRows" className="block text-gray-700 font-bold mb-2">
                    Total Rows
                </label>
                <input
                    type="text"
                    id="totalRows"
                    name="totalRows"
                    value={formData.totalRows}
                    onChange={handleInputChange}
                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                />
            </div>

            <div className="mb-4">
                <p className="block text-gray-700 font-bold mb-2">Day</p>
                {daysOfWeek.map((day) => (
                    <div className='flex items-center'>
                        <input type='checkbox'
                            key={day.value}
                            checked={selectedDays.includes(day.value)}
                            onChange={(e) => handleDayChange(e, day.value)}

                        />

                        <span className="ml-3 text-sm font-medium">{day.label}</span>

                    </div>

                ))}
            </div>
            <div className="mb-4">
                <label htmlFor="boardingPoint" className="block text-gray-700 font-bold mb-2">
                    Operator Id
                </label>
                <input
                    type="text"
                    id="operatorId"
                    name="operatorId"
                    value={formData.operatorId}
                    onChange={handleInputChange}
                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                />
            </div>
            <div className="mb-4">
                <label htmlFor="boardingPoint" className="block text-gray-700 font-bold mb-2">
                    Arrival Time
                </label>
                <input
                    type="text"
                    id="arrivalTime"
                    name="arrivalTime"
                    value={formData.arrivalTime}
                    onChange={handleInputChange}
                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                />
            </div>
            <div className="mb-4">
                <label htmlFor="boardingPoint" className="block text-gray-700 font-bold mb-2">
                    Departure Time
                </label>
                <input
                    type="text"
                    id="departureTime"
                    name="departureTime"
                    value={formData.departureTime}
                    onChange={handleInputChange}
                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                />

            </div>
            <div className="mb-4">
                <label htmlFor="boardingPoint" className="block text-gray-700 font-bold mb-2">
                    Source City
                </label>
                <input
                    type="text"
                    id="sourceCity"
                    name="sourceCity"
                    value={formData.sourceCity}
                    onChange={handleInputChange}
                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                />

            </div>
            <div className="mb-4">
                <label htmlFor="boardingPoint" className="block text-gray-700 font-bold mb-2">
                    Destination City
                </label>
                <input
                    type="text"
                    id="destinationCity"
                    name="destinationCity"
                    value={formData.destinationCity}
                    onChange={handleInputChange}
                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                />

            </div>
            <div className="mb-4">
                <label htmlFor="boardingPoint" className="block text-gray-700 font-bold mb-2">
                    Boarding Point
                </label>
                {boardingPoint.map((x, index) => (
                    <div className='flex gap-3'>
                        <input
                            placeholder='Boarding Time'
                            type="text"
                            id="time"
                            name="time"
                            value={x.time}
                            onChange={(e) => handleBoardingPoint(e, index)}
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                        />
                        <input

                            placeholder='Boarding Name'
                            type="text"
                            id="pointname"
                            name="pointname"
                            value={x.pointname}
                            onChange={(e) => handleBoardingPoint(e, index)}
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                        />
                        <input
                            placeholder='Boarding Address'
                            type="text"
                            id="pointAddress"
                            name="pointAddress"
                            value={x.pointAddress}
                            onChange={(e) => handleBoardingPoint(e, index)}
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                        />
                        <button className='bg-red-500 text-white p-2' onClick={() => handleRemoveBoardingButton(index)}>Remove</button>
                    </div>))}
                <button className='bg-blue-500 text-white p-2' onClick={() => handleAddBoardingButton()}>Add</button>
            </div>
            <div className="mb-4">
                <label htmlFor="droppingPoint" className="block text-gray-700 font-bold mb-2">
                    Dropping Point
                </label>
                {droppingPoint.map((x, index) => (
                    <div className='flex gap-3'>
                        <input
                            placeholder='Dropping Time'
                            type="text"
                            id="time"
                            name="time"
                            value={x.time}
                            onChange={(e) => handleDroppingPoint(e, index)}
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                        />
                        <input

                            placeholder='Dropping Name'
                            type="text"
                            id="pointname"
                            name="pointname"
                            value={x.pointname}
                            onChange={(e) => handleDroppingPoint(e, index)}
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                        />
                        <input
                            placeholder='Dropping Address'
                            type="text"
                            id="pointAddress"
                            name="pointAddress"
                            value={x.pointAddress}
                            onChange={(e) => handleDroppingPoint(e, index)}
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                        />
                        <button className='bg-red-500 text-white p-2' onClick={() => handleRemoveDroppingButton(index)}>Remove</button>
                    </div>))}
                <button className='bg-blue-500 text-white p-2' onClick={() => handleAddDroppingButton()}>Add</button>
            </div>
            <LowerSeatsData onClick={(column1, column2, column3) => setLowerSeats([column1, column2, column3])} />
            <UpperSeatsData onClick={(column1, column2, column3) => setUpperSeats([column1, column2, column3])} />

            <button type='submit' className='p-2 bg-blue-100 mt-5 ml-96' onClick={() => handleAddBus()} >ADD BUS</button>
        </form >
    )


}


export default AddBus
